import React, { useState, useEffect } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import * as Utils from '../../commons/utils/Utils'
import { Collapse, TextField, Grid, Box } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Switch from 'react-switch'

const STORAGE_KEY = 'SafeFeedbackRankingGridFilters'

const FILTER_STATE_INIT = {
	fechaDesde: '',
	fechaHasta: '',
	conductor: null,
	tipoFormulario: null,
	base: null,
	transportadora: null,
	centroCostos: null,
}

const QUERY_INIT = {
	fechaDesde: '',
	fechaHasta: '',
	conductorId: '',
	tipoFormularioId: '',
	baseId: '',
	transportadoraId: '',
	centroCostosId: '',
}

const handleInitFilters = () => {
	let storage = JSON.parse(window.localStorage.getItem(STORAGE_KEY))
	if (storage && storage.activo && storage.filtros) {
		return storage.filtros
	}
	return { ...FILTER_STATE_INIT }
}

const SafeFeedbackRankingGridFiltros = (props) => {
	const intl = useIntl()
	const [init, setInit] = useState(false)
	const [filtersLoading, setFiltersLoading] = useState(false)
	const [filtersState, setFiltersState] = useState(handleInitFilters())
	const [tiposFormularios, setTiposFormularios] = useState([])
	const [bases, setBases] = useState([])
	const [transportadoras, setTransportadoras] = useState([])
	const [centrosCostos, setCentrosCostos] = useState([])

	useEffect(() => {
		fetchData()
		initFilter()
	}, [])

	useEffect(() => {
		if (props.filterResetInputs) {
			setFiltersState({ ...FILTER_STATE_INIT })
			window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ activo: false, filtros: FILTER_STATE_INIT }))
		}
	}, [props.filterResetInputs])

	useEffect(() => {
		!props.dropdownActive && props.setFilterResetInputs(false)
		!props.dropdownActive && setFiltersLoading(false)
	}, [props.dropdownActive])

	useEffect(() => {
		if (init) {
			if (props.persisteFiltros) {
				window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ activo: true, filtros: filtersState }))
			} else {
				setFiltersState({ ...FILTER_STATE_INIT })
				props.setFilterQuery({ ...QUERY_INIT })
				window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ activo: false, filtros: FILTER_STATE_INIT }))
			}
		}
	}, [props.persisteFiltros])

	const initFilter = () => {
		if (props.persisteFiltros || validatorNotNull()) {
			props.setSearchActive(true)
		}
		const query = queryTable()
		setInit(true)
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ activo: props.persisteFiltros, filtros: filtersState }))
		props.setFilterQuery(query)
	}

	const fetchData = () => {
		setFiltersLoading(true)
		const tiposReq = Utils.getData('/safe-feedback-tipo-formularios?page=0&perPage=100')
			.then((data) => {
				setTiposFormularios(data && data.safeFeedbackTipoFormularios ? data.safeFeedbackTipoFormularios : [])
			})
			.catch(() => {})

		const basesReq = Utils.getData('/bases/select-filtered-by-user')
			.then((data) => { setBases(data || []) })
			.catch(() => {})

		const transportadorasReq = Utils.getData('/transportadoras/select')
			.then((data) => { setTransportadoras(data || []) })
			.catch(() => {})

		const centrosCostosReq = Utils.getData('/centros-costos/select')
			.then((data) => { setCentrosCostos(data || []) })
			.catch(() => {})

		Promise.all([tiposReq, basesReq, transportadorasReq, centrosCostosReq])
			.finally(() => { setFiltersLoading(false) })
	}

	const validatorNotNull = () => {
		return Object.values(filtersState).some((v) => {
			if (Array.isArray(v)) return v.length > 0
			return v !== null && v !== ''
		})
	}

	const handleChange = (name, value) => {
		setFiltersState((prev) => ({ ...prev, [name]: value }))
	}

	const queryTable = () => {
		return {
			fechaDesde: filtersState.fechaDesde || '',
			fechaHasta: filtersState.fechaHasta || '',
			conductorId: filtersState.conductor ? filtersState.conductor.id : '',
			tipoFormularioId: filtersState.tipoFormulario ? filtersState.tipoFormulario.id : '',
			baseId: filtersState.base ? filtersState.base.value : '',
			transportadoraId: filtersState.transportadora ? filtersState.transportadora.id : '',
			centroCostosId: filtersState.centroCostos ? (filtersState.centroCostos.id || filtersState.centroCostos.value) : '',
		}
	}

	const onChangePersistentFilter = (value) => {
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ activo: value, filtros: filtersState }))
		props.setPersisteFiltros(value)
	}

	const handleSubmit = (event) => {
		event.preventDefault()
		props.setSearchActive(true)
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ activo: props.persisteFiltros, filtros: filtersState }))
		props.setFilterQuery(queryTable())
	}

	const handleSubmitInto = (event) => {
		if (event.keyCode === 13) {
			event.preventDefault()
			handleSubmit(event)
		}
	}

	return (
		<>
			{init && (
				<Collapse in={props.dropdownActive}>
					<Grid container item xs={12} spacing={3} style={{ marginBottom: 20 }}>
						<Grid component={Box} item xs={2}>
							<form noValidate autoComplete="off" onSubmit={handleSubmit}>
								<TextField
									label={intl.formatMessage({ id: 'SafeFeedbackRankingGridFiltros.fecha_desde', defaultMessage: 'Fecha desde' })}
									name="fechaDesde"
									type="date"
									value={filtersState.fechaDesde}
									onChange={(e) => handleChange('fechaDesde', e.target.value)}
									disabled={filtersLoading}
									className="col-12"
									InputLabelProps={{ shrink: true }}
								/>
							</form>
						</Grid>
						<Grid component={Box} item xs={2}>
							<form noValidate autoComplete="off" onSubmit={handleSubmit}>
								<TextField
									label={intl.formatMessage({ id: 'SafeFeedbackRankingGridFiltros.fecha_hasta', defaultMessage: 'Fecha hasta' })}
									name="fechaHasta"
									type="date"
									value={filtersState.fechaHasta}
									onChange={(e) => handleChange('fechaHasta', e.target.value)}
									disabled={filtersLoading}
									className="col-12"
									InputLabelProps={{ shrink: true }}
								/>
							</form>
						</Grid>
						<Grid component={Box} item xs={3}>
							<Autocomplete
								size="small"
								name="tipoFormulario"
								options={tiposFormularios}
								value={filtersState.tipoFormulario}
								getOptionLabel={(option) => option ? option.nombre : ''}
								onChange={(e, value) => handleChange('tipoFormulario', value)}
								disabled={filtersLoading}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="standard"
										label={intl.formatMessage({ id: 'SafeFeedbackRankingGridFiltros.tipo_formulario', defaultMessage: 'Tipo de formulario' })}
									/>
								)}
							/>
						</Grid>
						<Grid component={Box} item xs={3}>
							<Autocomplete
								size="small"
								name="base"
								options={bases}
								value={filtersState.base}
								getOptionLabel={(option) => option ? option.label : ''}
								onChange={(e, value) => handleChange('base', value)}
								disabled={filtersLoading}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="standard"
										label={intl.formatMessage({ id: 'SafeFeedbackRankingGridFiltros.base', defaultMessage: 'Base' })}
									/>
								)}
							/>
						</Grid>
						<Grid component={Box} item xs={3}>
							<Autocomplete
								size="small"
								name="transportadora"
								options={transportadoras}
								value={filtersState.transportadora}
								getOptionLabel={(option) => option ? option.nombre : ''}
								onChange={(e, value) => handleChange('transportadora', value)}
								disabled={filtersLoading}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="standard"
										label={intl.formatMessage({ id: 'SafeFeedbackRankingGridFiltros.transportadora', defaultMessage: 'Transportadora' })}
									/>
								)}
							/>
						</Grid>
						<Grid component={Box} item xs={3}>
							<Autocomplete
								size="small"
								name="centroCostos"
								options={centrosCostos}
								value={filtersState.centroCostos}
								getOptionLabel={(option) => option ? option.label : ''}
								onChange={(e, value) => handleChange('centroCostos', value)}
								disabled={filtersLoading}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="standard"
										label={intl.formatMessage({ id: 'SafeFeedbackRankingGridFiltros.centro_costos', defaultMessage: 'Centro de costo' })}
									/>
								)}
							/>
						</Grid>
						<Grid
							xs={12}
							container
							justifyContent="space-between"
							alignItems="center"
						>
							<Grid component={Box} item xs={2} className="align-self-end">
								<div className="d-flex inline justify-content-around align-items-center">
									<FormattedMessage
										id="SafeFeedbackRankingGridFiltros.persistir_filtros"
										defaultMessage="Persistir Filtros"
									/>
									<Switch
										onChange={(value) => onChangePersistentFilter(value)}
										checked={props.persisteFiltros}
										disabled={filtersLoading}
										offColor="#FF4961"
										onColor="#28D094"
									/>
								</div>
							</Grid>
							<Grid component={Box} item className="align-self-end">
								<button
									disabled={filtersLoading}
									className="btn btn-primary mr-1"
									onClick={(e) => handleSubmit(e)}
								>
									<i className="fa fa-search fa-xs" />{'   '}
									<FormattedMessage id="Buscar" defaultMessage="Buscar" />
								</button>
							</Grid>
						</Grid>
					</Grid>
				</Collapse>
			)}
		</>
	)
}

export default SafeFeedbackRankingGridFiltros
